export const IMPORT_EXPORT_ENTITY_TYPE_ACTIVITY_LIST: string = 'activity-list';
export const IMPORT_EXPORT_ENTITY_TYPE_ASSET_LIST: string = 'asset-list';
export const IMPORT_EXPORT_ENTITY_TYPE_CONTACT_LIST: string = 'contact-list';
export const IMPORT_EXPORT_ENTITY_TYPE_DEAL_LIST: string = 'deal-list';
export const IMPORT_EXPORT_ENTITY_TYPE_DEAL: string = 'deal';
export const IMPORT_EXPORT_ENTITY_TYPE_DEAL_FILE_LIST: string = 'deal-file-list';
export const IMPORT_EXPORT_ENTITY_TYPE_DEAL_TASK_LIST: string = 'deal-task-list';
